import { Button, Modal } from '@finbeat/react-toolkit';
import Id from 'models/id';
import { OrderInfoProvider } from 'providers/OrderInfoProvider';
import { useRef } from 'react';
import { Trans } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Info, useOrderGeneralInfo } from '../Order/OrderInfoData';

type OrderInfoModalProps = Id & {
    isOpen?: boolean;
    toggle: (item: string) => void;
};

const OrderInfoModal = ({ id, isOpen, toggle }: OrderInfoModalProps) => {
    const { orderDetails } = useOrderGeneralInfo(id);
    const modalRef = useRef(null);
    const navigate = useNavigate();

    return orderDetails ? (
        <Modal size="xl" isOpen={isOpen} toggle={() => toggle('')} scrollable innerRef={modalRef}>
            <ModalHeader toggle={() => toggle('')}>#{id}</ModalHeader>
            <ModalBody className={`client-order-modal__body`}>
                <OrderInfoProvider
                    orderDetails={orderDetails}
                    onSubmitOrderSuccess={() => navigate('/order')}
                >
                    <Info isModal modalRef={modalRef} />
                </OrderInfoProvider>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={() => toggle('')}>
                    <Trans i18nKey="BackOfficeCancel" />
                </Button>
            </ModalFooter>
        </Modal>
    ) : (
        <></>
    );
};

export default OrderInfoModal;
